'use strict';
import {
  ASSET_ITEM_NAME,
  ASSET_PROJECT_ITEM_NAME,
  ORG_PROFILE_ITEM_NAME,
  ORGANIZATION_ITEM_NAME,
  PROJECT_ITEM_NAME,
} from '../redux/state';


export function getModelState(rootState) {
  return rootState.model;
}

function getReduxItems(rootState) {
  return getModelState(rootState).observables;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getAssetReduxItem(rootState) {
  return getReduxItems(rootState)[ASSET_ITEM_NAME];
}

/**
 * @param rootState
 * @return {Object}
 */
export function getAssetModel(rootState) {
  return getAssetReduxItem(rootState).item;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getAssetProjectReduxItem(rootState) {
  return getReduxItems(rootState)[ASSET_PROJECT_ITEM_NAME];
}

/**
 * @param rootState
 * @return {Object}
 */
export function getAssetProjectModel(rootState) {
  return getAssetProjectReduxItem(rootState).item;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getOrganizationReduxItem(rootState) {
  return getReduxItems(rootState)[ORGANIZATION_ITEM_NAME];
}

/**
 * @param rootState
 * @return {Object}
 */
export function getOrganizationModel(rootState) {
  return getOrganizationReduxItem(rootState).item;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getOrgProfileReduxItem(rootState) {
  return getReduxItems(rootState)[ORG_PROFILE_ITEM_NAME];
}

/**
 * @param rootState
 * @return {Object}
 */
export function getOrgProfileModel(rootState) {
  return getOrgProfileReduxItem(rootState).item;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getProjectReduxItem(rootState) {
  return getReduxItems(rootState)[PROJECT_ITEM_NAME];
}

/**
 * @param rootState
 * @return {Object}
 */
export function getProjectModel(rootState) {
  return getProjectReduxItem(rootState).item;
}

// Legacy model state:

export function getUserPrefsState(rootState) {
  return rootState.userPrefs;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getAsset(rootState) {
  return getModelState(rootState).asset;
}

/**
 * @param rootState
 * @return {Object}
 * @return {*|assetProject|{get, set}|{type, domainClass}|null|Object}
 */
export function getAssetProject(rootState) {
  return getModelState(rootState).assetProject;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getOrganization(rootState) {
  return getModelState(rootState).organization;
}

/**
 * @param rootState
 * @return {Object}
 * @return {*|modelState.orgProfile|{role, email, aliasFor, avatar, avc}|orgProfile|{get}|Object}
 */
export function getOrgProfile(rootState) {
  return getModelState(rootState).orgProfile;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getProject(rootState) {
  return getModelState(rootState).project;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getUser(rootState) {
  return getModelState(rootState).user;
}

/**
 * @param rootState
 * @return {Object}
 */
export function getUserProfile(rootState) {
  return getModelState(rootState).userProfile;
}




// WEBPACK FOOTER //
// ./src/js/app/model/reducers/state.js